import { RootState } from 'shared/types/store';

export const selectUser = (state: RootState) => state.profile.user;

export const selectTemporaryUser = (state: RootState) =>
  state.profile.temporaryUser;

export const selectInviteSuccess = (state: RootState) =>
  state.profile.acceptInvite;
